import React from 'react';

const SearchBar = ({ onSearch }) => {
  return (
    <div className="container mt-3 p-0">
      <input
        type="text"
        className="form-control"
        placeholder="Search by keyword or phrase..."
        onChange={(e) => onSearch(e.target.value)}
      />
    </div>
  );
};

export default SearchBar;
